import {Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output} from "@angular/core";
import {FilterModelDto} from "../../models/filter.model";
import {FilterSettingService} from "../../services/filter-setting.service";
import {Subscription} from "rxjs";

@Component({
  selector: "app-datepicker",
  templateUrl: "./datepicker.component.html",
  styleUrls: ["./datepicker.component.scss"],
})
export class DatepickerComponent implements OnInit, OnDestroy {
  @Input() isStartDate = false;
  @Input() isDisable = false;
  @Input() filter!: FilterModelDto;
  @Input() date?: Date;
  @Input() isFull = false;
  @Input() horizontalPosition: "bottom" | "top" | "center" | "semi-top" = "bottom";
  @Input() verticalPosition: "left" | "right" = "left";
  @Output() setData: EventEmitter<Date> = new EventEmitter<Date>();

  mount!: number;
  year!: number;
  dayWeek: any;

  countMountDays = [31, 0, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  daysArray: number[] = [];

  selectedDate?: Date;
  selectedHours = "23";
  selectedMinute = "59";
  selectedSecond = "59";

  isOpenDatePicker = false;

  subs: Subscription[] = [];

  @HostListener("document:click", ["$event"])
  clickOut(event: MouseEvent) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.isOpenDatePicker = false;
    }
  }

  constructor(
    private eRef: ElementRef,
    private filterSettingService: FilterSettingService
  ) {
  }

  ngOnInit() {
    this.initCalendar();
    this.resetListener();

    if (this.isStartDate) {
      this.selectedHours = "00";
      this.selectedMinute = "00";
      this.selectedSecond = "00";
    }
  }

  ngOnDestroy() {
    this.subs.forEach((item) => item.unsubscribe());
  }

  initCalendar() {
    const date = new Date();
    this.year = date.getFullYear();
    this.mount = date.getMonth();
    this.getFistDayWeek();
  }

  resetListener() {
    this.subs.push(
      this.filterSettingService.filterItemReset$.subscribe({
        next: (res) => {
          if (this.filter.fieldName === res.fieldName) {
            this.resetCalendar();
          }
        },
      })
    );

    this.subs.push(
      this.filterSettingService.filterAllReset$.subscribe({
        next: () => {
          this.resetCalendar();
        },
      })
    );
  }

  resetCalendar() {
    this.date = this.selectedDate = undefined;
    this.initCalendar();
  }

  getFistDayWeek() {
    this.daysArray = [];
    const date = new Date(this.year, this.mount, 1);
    this.dayWeek = date.getDay();

    // Опеределяем высокосный год
    let days: number = this.countMountDays[this.mount];
    if (days === 0) {
      if ((this.year % 4 == 0 && this.year % 100 != 0) || this.year % 400 == 0) {
        days = 29;
      } else {
        days = 28;
      }
    }

    // Заполняем массив числами месяца
    if (this.dayWeek === 0) {
      for (let i = 0; i < 6; i++) {
        this.daysArray.push(0);
      }
      for (let i = 0; i < days; i++) {
        this.daysArray.push(i + 1);
      }
      return;
    }

    for (let i = 0; i < this.dayWeek - 1; i++) {
      this.daysArray.push(0);
    }

    for (let i = 0; i < days; i++) {
      this.daysArray.push(i + 1);
    }
  }

  nextMount() {
    if (this.mount !== 0) {
      this.mount--;
    } else {
      this.year--;
      this.mount = 11;
    }
    this.getFistDayWeek();
  }

  prevMount() {
    if (this.mount !== 11) {
      this.mount++;
    } else {
      this.year++;
      this.mount = 0;
    }
    this.getFistDayWeek();
  }

  setDay(year: number, mount: number, day: number | undefined) {
    if (day === 0) {
      return;
    }
    this.selectedDate = new Date(year, mount, day, +this.selectedHours, +this.selectedMinute, +this.selectedSecond);
  }

  setHours() {
    if (+this.selectedHours > 23) {
      this.selectedHours = "23";
    }
    this.setTime();
  }

  setMinutes() {
    if (+this.selectedMinute > 59) {
      this.selectedMinute = "59";
    }
    this.setTime();
  }

  setSecond() {
    if (+this.selectedSecond > 59) {
      this.selectedSecond = "59";
    }
    this.setTime();
  }

  setTime() {
    if (this.selectedDate) {
      this.setDay(this.selectedDate.getFullYear(), this.selectedDate.getMonth(), this.selectedDate.getDate());
    }
  }

  selectDateAndTime() {
    if (this.selectedDate) {
      this.date = this.selectedDate;

      const filterData: FilterModelDto = {
        fieldName: this.filter?.fieldName,
        value: this.toLocalISOString(this.selectedDate),
        description: this.selectedDate.toLocaleString(),
      };

      if (!this.isFull) {
        this.filterSettingService.filterSet$.next(filterData);
      } else {
        this.setData.emit(this.selectedDate);
      }
    }

    this.closeDatePicker();
  }

  private toLocalISOString(date: Date) {
    const pad = (number: number) => (number < 10 ? "0" : "") + number;

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());
    const milliseconds = (date.getMilliseconds() / 1000).toFixed(3).slice(2, 5);

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`;
  }

  closeDatePicker() {
    this.isOpenDatePicker = false;
  }

  openDatePicker() {
    if (!this.isDisable) {
      this.isOpenDatePicker = !this.isOpenDatePicker;
    }
  }
}
